import { Card, CardContent, CardHeader, CardTitle, cn, Skeleton } from '@1trading/react';

interface StatsCardProps {
  label: string;
  value: React.ReactNode;
  subtitle?: string;
  isLoading?: boolean;
  /** Renders the value in the destructive color (legacy `negative`) */
  negative?: boolean;
  /** Draws a thick left border in this CSS colour */
  borderLeftColor?: string;
}

export const StatsCard = ({ label, value, subtitle, isLoading = false, negative = false, borderLeftColor }: StatsCardProps) => (
  <Card className={cn('text-center', borderLeftColor && 'border-l-8')} style={borderLeftColor ? { borderLeftColor } : undefined}>
    <CardHeader>
      <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
    </CardHeader>
    <CardContent className="flex flex-col items-center gap-1">
      {isLoading ? <Skeleton className="h-10 w-32" /> : <span className={cn('text-4xl font-bold', negative ? 'text-red-500' : 'text-primary')}>{value}</span>}
      {subtitle ? <span className="text-xs text-muted-foreground">{subtitle}</span> : null}
    </CardContent>
  </Card>
);
StatsCard.displayName = 'StatsCard';
